import { useObservable } from "@rsm";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { useMainNavigate } from "hooks/useMainNavigate";
import { useResultsModuleBLoC } from "modules/ResultsModule/ResultsModule.bloc";
import { ResultsModuleHelpers } from "modules/ResultsModule/ResultsModule.helpers";
import React, { useEffect } from "react";
import { Globals } from "types/globals";

export const ResultsLandingPage: React.FC<{}> = () => {
  const { project$, followUpQuestions$ } = useResultsModuleBLoC();
  const project = useObservable(project$);
  const followUpQuestions = useObservable(followUpQuestions$);
  const navigate = useMainNavigate();

  useEffect(() => {
    switch (project?.projectType) {
      case "idea":
      case "message":
        project.frameworkId === Globals.Frameworks.PriceSensitivity
          ? navigate(ResultsModuleHelpers.internalResultsLink(project.id, "price-sensitivity"), {
              replace: true,
            })
          : navigate(ResultsModuleHelpers.internalResultsLink(project.id, "all"), { replace: true });
        break;
      case "npd":
        navigate(ResultsModuleHelpers.internalResultsLink(project.id, "npd"), { replace: true });
        break;
      case "question":
        project.frameworkId === Globals.Frameworks.CategorySeeding
          ? navigate(ResultsModuleHelpers.internalResultsLink(project.id, "profile-questions"), {
              replace: true,
            })
          : followUpQuestions?.length &&
            navigate(
              ResultsModuleHelpers.internalResultsLink(
                project.id,
                `${followUpQuestions[0]!.question.questionTypeId === Globals.QuestionType.text ? "text" : "qual"}/${followUpQuestions[0]!.id}`,
              ),
              { replace: true },
            );
        break;
      default:
        break;
    }
  }, [project, navigate, followUpQuestions]);
  return <LoadingPage />;
};
